<template>
  <div>
    <nav
      id="main-navbar"
      class="navbar navbar-expand-lg notCollapseNav"
      :class="[
        isMobile ? 'mobilenav' : '',
        navBooker,
        isSidebarRedesign ? 'sidebar-redesign-nav' : '',
      ]"
      :style="bgGrayBooker"
    >
      <button
        v-show="false"
        class="navbar-toggler float-left position-absolute left0 card bg-primary"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        ref="toggleMenu2"
      >
        <span class="icon-more_horiz text-white"></span>
      </button>

      <div
        class="collapse navbar-collapse"
        :style="bgGrayBooker"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav">
          <img
            v-if="!isMobile"
            :src="logo"
            :class="[
              isBookerSidebar && !isSidebarRedesign
                ? 'logoMerciHubert'
                : 'logooliver',
              isSidebarRedesign
                ? 'ol-sidebar-brand'
                : 'rounded mx-auto d-block mb-4',
            ]"
          />

          <div
            v-if="isBookerSidebar"
            :class="{ 'sidebar-redesign-gate': isSidebarRedesign }"
            class="sidebar-booker-host w-100"
          >
            <SidebarBooker />
          </div>

          <div
            v-else-if="
              menu &&
              !isBdrUser([
                'Screening',
                'Onboarding',
                'Rejected (interview)',
                'Outdated',
                'Rejected (trial)',
                'Stopped',
              ])
            "
          >
            <div
              v-if="
                (agency_signed && user.role_id != 4) ||
                (user.role_id == 4 && user.order_created == 1)
              "
              :class="{ 'sidebar-redesign-gate': isSidebarRedesign }"
            >
              <!-- Admin sidebar (role_id === 1) -->
              <div
                v-if="isAdminSidebarRedesign"
                class="sidebar-admin-layout w-100"
              >
                <div class="sidebar-admin-scroll sidebar-redesign">
                  <template v-for="family in adminMenuFamilies">
                    <div
                      v-if="adminFamilyHasVisibleEntries(family)"
                      :key="family.key"
                      class="ol-sidebar-family"
                    >
                      <div class="ol-family-label">{{ family.label }}</div>

                      <template v-for="(entry, entryIdx) in family.entries">
                        <!-- Paramètres -->
                        <router-link
                          v-if="entry.type === 'settings' && adminShowSettings"
                          :key="family.key + '-settings-' + entryIdx"
                          :to="'/settings-account'"
                          class="ol-nav-item-link"
                          active-class="ol-active"
                          @mousedown.native="mousedown('/settings-account')"
                          @click.native="openCloseSubmenu(null, true)"
                        >
                          <div class="ol-nav-item">
                            <span class="ol-nav-icon">
                              <SidebarIcon name="settings" />
                            </span>
                            <span class="ol-nav-label">{{
                              $t("lang.button.settings")
                            }}</span>
                          </div>
                        </router-link>

                        <!-- Item con submenú -->
                        <div
                          v-else-if="
                            resolveAdminMenuLink(entry) &&
                            resolveAdminMenuLink(entry).submenu &&
                            isAdminMenuLinkVisible(resolveAdminMenuLink(entry))
                          "
                          :key="
                            family.key +
                            '-group-' +
                            (entry.menuId || entry.linkTo)
                          "
                          class="ol-nav-group"
                          :class="{
                            open: resolveAdminMenuLink(entry).showSubmenu,
                          }"
                        >
                          <div
                            class="ol-nav-item ol-nav-item--parent"
                            @click="
                              openCloseSubmenu(resolveAdminMenuLink(entry).id)
                            "
                          >
                            <span class="ol-nav-icon">
                              <SidebarIcon
                                v-if="adminSidebarIconName(entry)"
                                :name="adminSidebarIconName(entry)"
                              />
                              <i
                                v-else
                                :class="resolveAdminMenuLink(entry).icon"
                              ></i>
                            </span>
                            <span class="ol-nav-label">{{
                              resolveAdminMenuLink(entry).name
                            }}</span>
                            <i
                              class="fa fa-chevron-down ol-chev"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div
                            v-show="resolveAdminMenuLink(entry).showSubmenu"
                            class="ol-submenu"
                          >
                            <router-link
                              v-for="(sublink, subIdx) in adminOrderedSubmenu(
                                resolveAdminMenuLink(entry),
                                entry.submenuOrder
                              )"
                              :key="
                                family.key +
                                '-sub-' +
                                subIdx +
                                '-' +
                                sublink.linkTo
                              "
                              :to="sublink.linkTo"
                              class="ol-sub-item-link"
                              active-class="ol-active"
                              @mousedown.native="
                                adminSubmenuMousedown(
                                  resolveAdminMenuLink(entry),
                                  sublink
                                )
                              "
                            >
                              <div class="ol-sub-item">
                                <i
                                  class="icon-caret-right1"
                                  aria-hidden="true"
                                ></i>
                                <span class="ol-sub-label">{{
                                  sublink.name
                                }}</span>
                                <span
                                  v-if="sublink.count && sublink.count != '0'"
                                  class="ol-badge"
                                  >{{ sublink.count }}</span
                                >
                                <span
                                  v-else-if="
                                    sublink.hasCounter && !sublink.count
                                  "
                                  class="ol-badge ol-badge--loading"
                                  >…</span
                                >
                              </div>
                            </router-link>
                          </div>
                        </div>

                        <!-- Item plano -->
                        <router-link
                          v-else-if="
                            resolveAdminMenuLink(entry) &&
                            !resolveAdminMenuLink(entry).submenu &&
                            isAdminMenuLinkVisible(resolveAdminMenuLink(entry))
                          "
                          :key="
                            family.key +
                            '-link-' +
                            (entry.menuId || entry.linkTo)
                          "
                          :to="resolveAdminMenuLink(entry).linkTo"
                          class="ol-nav-item-link"
                          active-class="ol-active"
                          @mousedown.native="
                            adminItemMousedown(resolveAdminMenuLink(entry))
                          "
                          @click.native="openCloseSubmenu(null, true)"
                        >
                          <div class="ol-nav-item">
                            <span class="ol-nav-icon">
                              <SidebarIcon
                                v-if="adminSidebarIconName(entry)"
                                :name="adminSidebarIconName(entry)"
                              />
                              <i
                                v-else
                                :class="resolveAdminMenuLink(entry).icon"
                              ></i>
                            </span>
                            <span class="ol-nav-label">{{
                              resolveAdminMenuLink(entry).name
                            }}</span>
                            <span
                              v-if="
                                resolveAdminMenuLink(entry).count &&
                                resolveAdminMenuLink(entry).count != '0'
                              "
                              class="ol-badge"
                              >{{ resolveAdminMenuLink(entry).count }}</span
                            >
                            <span
                              v-else-if="
                                resolveAdminMenuLink(entry).hasCounter &&
                                !resolveAdminMenuLink(entry).count
                              "
                              class="ol-badge ol-badge--loading"
                              >…</span
                            >
                          </div>
                        </router-link>
                      </template>
                    </div>
                  </template>

                  <!-- Ítems admin no listados en el mockup pero visibles por permisos -->
                  <template v-for="index in adminOrphanMenuIndices">
                    <router-link
                      v-if="menu[index] && !menu[index].submenu"
                      :key="'orphan-link-' + index"
                      :to="menu[index].linkTo"
                      class="ol-nav-item-link"
                      active-class="ol-active"
                      @mousedown.native="adminItemMousedown(menu[index], index)"
                      @click.native="openCloseSubmenu(null, true)"
                    >
                      <div class="ol-nav-item">
                        <span class="ol-nav-icon">
                          <SidebarIcon
                            v-if="adminOrphanSidebarIconName(menu[index])"
                            :name="adminOrphanSidebarIconName(menu[index])"
                          />
                          <i v-else :class="menu[index].icon"></i>
                        </span>
                        <span class="ol-nav-label">{{ menu[index].name }}</span>
                        <span
                          v-if="menu[index].count && menu[index].count != '0'"
                          class="ol-badge"
                          >{{ menu[index].count }}</span
                        >
                        <span
                          v-else-if="
                            menu[index].hasCounter && !menu[index].count
                          "
                          class="ol-badge ol-badge--loading"
                          >…</span
                        >
                      </div>
                    </router-link>
                    <div
                      v-else-if="menu[index] && menu[index].submenu"
                      :key="'orphan-group-' + index"
                      class="ol-nav-group"
                      :class="{ open: menu[index].showSubmenu }"
                    >
                      <div
                        class="ol-nav-item ol-nav-item--parent"
                        @click="openCloseSubmenu(menu[index].id)"
                      >
                        <span class="ol-nav-icon">
                          <SidebarIcon
                            v-if="adminOrphanSidebarIconName(menu[index])"
                            :name="adminOrphanSidebarIconName(menu[index])"
                          />
                          <i v-else :class="menu[index].icon"></i>
                        </span>
                        <span class="ol-nav-label">{{ menu[index].name }}</span>
                        <i
                          class="fa fa-chevron-down ol-chev"
                          aria-hidden="true"
                        ></i>
                      </div>
                      <div v-show="menu[index].showSubmenu" class="ol-submenu">
                        <router-link
                          v-for="(sublink, subIdx) in linkSubmenu(
                            menu[index].submenu
                          )"
                          :key="'orphan-sub-' + index + '-' + subIdx"
                          :to="sublink.linkTo"
                          class="ol-sub-item-link"
                          active-class="ol-active"
                          @mousedown.native="
                            adminSubmenuMousedown(menu[index], sublink, index)
                          "
                        >
                          <div class="ol-sub-item">
                            <i
                              class="icon-caret-right1"
                              aria-hidden="true"
                            ></i>
                            <span class="ol-sub-label">{{ sublink.name }}</span>
                            <span
                              v-if="sublink.count && sublink.count != '0'"
                              class="ol-badge"
                              >{{ sublink.count }}</span
                            >
                            <span
                              v-else-if="sublink.hasCounter && !sublink.count"
                              class="ol-badge ol-badge--loading"
                              >…</span
                            >
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="ol-sidebar-footer sidebar-admin-footer">
                  <a
                    v-if="adminShowHelp"
                    target="_blank"
                    class="ol-nav-item-link"
                    href="https://help.oliverlist.com/knowledge"
                  >
                    <div class="ol-nav-item">
                      <span class="ol-nav-icon">
                        <SidebarIcon name="help" />
                      </span>
                      <span class="ol-nav-label">{{
                        $t("lang.button.help")
                      }}</span>
                    </div>
                  </a>
                  <router-link
                    :to="'/login'"
                    class="ol-nav-item-link"
                    @mousedown.native="mousedown('/login')"
                  >
                    <div class="ol-nav-item">
                      <span class="ol-nav-icon">
                        <SidebarIcon name="logout" :size="16" />
                      </span>
                      <span class="ol-nav-label">{{
                        $t("lang.button.logout")
                      }}</span>
                    </div>
                  </router-link>
                </div>
              </div>

              <!-- SIDEBAR PARA VISTA BILLING -->
              <div v-else-if="isClientSidebar" class="sidebar-client-host">
                <SidebarClient />
              </div>

              <template v-else-if="!isBookerSidebar">
                <div v-for="(link, index) in menu" :key="index">
                  <router-link
                    :class="hoverClassBooker"
                    v-if="!link.submenu"
                    :to="link.linkTo"
                    @mousedown.native="
                      checkPlan(index)
                        ? mousedown(link.linkTo)
                        : restrictedAccess()
                    "
                  >
                    <li
                      class="nav-item py-0 px-1 m-0"
                      :style="bgGrayBooker"
                      v-if="checkRol(index) && specialFilterMenu(link)"
                      @click="openCloseSubmenu(null, true)"
                    >
                      <div
                        :class="'text-left my-0 py-1 ' + textDark"
                        class="nav-link"
                      >
                        <div class="d-inline">
                          <i :class="[link.icon, textDark]"></i>
                          <small
                            class="pl-0"
                            v-if="false && link.linkTo == '/opportunities'"
                          >
                            <transition enter-active-class="animated tada">
                              <span
                                v-show="
                                  notifications > 0 &&
                                  !(
                                    user.team_role_id !== undefined &&
                                    user.team_role_id == 3
                                  )
                                "
                                enter-active-class="animated tada"
                                class="minimize-linkedin mr-1 position-absolute float-right btn btn-sm btn-primary"
                              >
                                {{ notifications }}
                              </span>
                            </transition>
                          </small>
                        </div>
                        <span class="item-name ml-2" :class="textDark">
                          <span class="title">{{ link.name }}</span>

                          <span
                            v-if="link.count && link.count != '0'"
                            class="ml-1 p-0 circle bg-primary text-center"
                            >{{ link.count }}</span
                          >
                          <span
                            v-if="link.hasCounter && !link.count"
                            class="ml-1 p-0 circle bg-primary text-center"
                            >...</span
                          >
                        </span>
                      </div>
                    </li>
                  </router-link>

                  <!-- si tiene submenu -->
                  <div :style="bgGrayBooker" class="d-inline p-0 m-0" v-else>
                    <li
                      class="nav-item py-1 px-1 ml-2"
                      v-if="checkRol(index)"
                      :class="hoverClassBooker"
                    >
                      <div :class="'text-left mr-5' + textDark">
                        <i :class="[link.icon, textDark]"></i>
                        <span
                          @click="openCloseSubmenu(link.id)"
                          class="ml-2 cursor-pointer"
                          :class="textDark"
                        >
                          {{ link.name }}
                          <small v-if="link.showSubmenu" :class="iconColor"
                            ><i
                              class="fa-solid fa-chevron-down"
                              :class="textDark"
                            ></i
                          ></small>
                          <small v-else :class="textDark"
                            ><i
                              class="fa-solid fa-chevron-up"
                              :class="textDark"
                            ></i
                          ></small>
                          <small v-if="link.hasTasks && false"
                            ><i class="ml-2 text-primary icon-circle"></i
                          ></small>
                        </span>

                        <template v-if="link.showSubmenu">
                          <div
                            class="h6"
                            :class="hoverClassBooker"
                            v-for="(sublink, i) in linkSubmenu(link.submenu)"
                            :key="i"
                          >
                            <router-link
                              :class="hoverClassBooker"
                              :to="sublink.linkTo"
                              @mousedown.native="
                                checkPlan(index)
                                  ? mousedown(sublink.linkTo)
                                  : restrictedAccess()
                              "
                            >
                              <li
                                class="nav-item my-2 px-0 py-0"
                                :class="hoverClassBooker"
                              >
                                <div
                                  class="text-left small ml-0 pl-2 pr-0 nav-link my-0 py-0"
                                  :class="textDark"
                                >
                                  <div class="d-inline">
                                    <i :class="[sublink.icon, textDark]"></i>
                                    <small
                                      class="pl-0"
                                      v-if="
                                        false &&
                                        sublink.linkTo == '/opportunities'
                                      "
                                    >
                                      <transition
                                        enter-active-class="animated tada"
                                      >
                                        <span
                                          v-show="
                                            notifications > 0 &&
                                            !(
                                              user.team_role_id !== undefined &&
                                              user.team_role_id == 3
                                            )
                                          "
                                          enter-active-class="animated tada"
                                          class="minimize-linkedin mr-1 position-absolute float-right btn btn-sm btn-primary"
                                        >
                                          {{ notifications }}
                                        </span>
                                      </transition>
                                    </small>
                                  </div>
                                  <span class="title-name ml-1">
                                    <span class="title">{{
                                      sublink.name
                                    }}</span>
                                    <span
                                      v-if="
                                        sublink.count && sublink.count != '0'
                                      "
                                      class="ml-1 p-0 circle bg-primary text-center"
                                      >{{ sublink.count }}</span
                                    >
                                    <span
                                      v-if="
                                        sublink.hasCounter && !sublink.count
                                      "
                                      class="ml-1 p-0 circle bg-primary text-center"
                                      >...</span
                                    >
                                  </span>
                                </div>
                              </li>
                            </router-link>
                          </div>
                        </template>
                      </div>
                    </li>
                  </div>

                  <span
                    v-if="
                      minlink &&
                      link.linkTo == '/dashboard' &&
                      $route.fullPath !== '/mysearchs/mysearch' &&
                      $route.fullPath !== '/mysearchs'
                    "
                    @click="toggleMinLink()"
                    class="pb-4 align-center position-absolute p-1 notif cursor-pointer text-white"
                  >
                    <strong
                      class="ease-in-out bg-primary pt-1 px-1 mb-2 rounded"
                    >
                      <i class="icon-plus"></i
                    ></strong>
                  </span>

                  <span
                    v-if="
                      minondemand &&
                      link.linkTo == '/dashboard' &&
                      $route.fullPath !== '/mysearchs/mysearch' &&
                      $route.fullPath !== '/mysearchs'
                    "
                    @click="toggleMinOndemand()"
                    class="pb-4 align-center position-absolute p-1 notif cursor-pointer text-white"
                  >
                    <strong
                      class="ease-in-out bg-primary pt-1 px-1 mb-2 rounded"
                    >
                      <i class="icon-plus"></i
                    ></strong>
                  </span>
                </div>
              </template>
            </div>

            <!-- <div class="divider bg-white mt-3"></div> -->

            <router-link
              :class="hoverClassBooker"
              :to="'/checklist'"
              v-if="false"
              @mousedown.native="mousedown('/checklist')"
            >
              <li class="nav-item py-0 px-1 m-0" :style="bgGrayBooker">
                <div class="nav-link text-left" :class="textDark" href>
                  <div class="d-inline">
                    <i class="icon-checkmark"></i>
                  </div>
                  <span class="item-name ml-2">
                    <span class="title">{{ $t("lang.checklist.link") }} </span>
                    <span
                      v-if="this.$store.state.authentication.checklist > 0"
                      class="minimize-linkedin mr-1 position-absolute float-right btn btn-sm btn-primary"
                    >
                      {{ this.$store.state.authentication.checklist }}
                    </span>
                  </span>
                </div>
              </li>
            </router-link>

            <div v-if="isUserBookerRecuiter">
              <router-link
                :class="hoverClassBooker"
                :to="'/dashboard/tabs/21'"
                @mousedown.native="mousedown('/dashboard/tabs/21')"
              >
                <li class="nav-item py-0 px-1 m-0" :style="bgGrayBooker">
                  <div
                    class="nav-link text-left"
                    :class="[
                      isUserBilling
                        ? 'billingClassMenu nav-link text-left'
                        : '',
                      textDark,
                    ]"
                    href
                  >
                    <div class="d-inline">
                      <i class="fa-solid fa-chart-line" :class="textDark"></i>
                    </div>
                    <span class="item-name ml-2" :class="textDark">
                      <span class="title">Metrics</span>
                    </span>
                  </div>
                </li>
              </router-link>
            </div>

            <router-link
              :class="hoverClassBooker"
              v-if="
                !isSidebarRedesign &&
                !(isUserOperational || isUserContable || isUserAttendance)
              "
              :to="'/settings-account'"
              @mousedown.native="mousedown('/settings-account')"
            >
              <li
                class="nav-item py-0 px-1 m-0"
                :style="bgGrayBooker"
                @click="openCloseSubmenu(null, true)"
              >
                <div
                  class="nav-link text-left"
                  :class="[
                    isUserBilling ? 'billingClassMenu nav-link text-left' : '',
                    textDark,
                  ]"
                  href
                >
                  <div class="d-inline">
                    <i class="icon-gear" :class="textDark"></i>
                  </div>
                  <span class="item-name ml-2" :class="textDark">
                    <span class="title">{{ $t("lang.button.settings") }}</span>
                  </span>
                </div>
              </li>
            </router-link>

            <div v-if="!isClientSidebar && hasPermissions(['billing'])">
              <router-link
                :class="hoverClassBooker"
                :to="'/client-docs'"
                @mousedown.native="mousedown('/client-docs')"
              >
                <li class="nav-item py-0 px-1 m-0" :style="bgGrayBooker">
                  <div class="nav-link text-left" :class="textDark" href>
                    <div class="d-inline">
                      <i class="icon-file-text" :class="textDark"></i>
                    </div>
                    <span class="item-name ml-2" :class="textDark">
                      <span class="title">Client Docs</span>
                    </span>
                  </div>
                </li>
              </router-link>
            </div>

            <a
              v-if="
                !isSidebarRedesign &&
                !(
                  (user.team_role_id !== undefined && user.team_role_id == 3) ||
                  user.role_id == 4 ||
                  isUserOperational ||
                  isUserContable ||
                  isUserBookerRecuiter ||
                  isUserAttendance
                )
              "
              target="_blank"
              :class="hoverClassBooker"
              href="https://help.oliverlist.com/knowledge"
            >
              <li class="nav-item py-0 px-1 m-0" :style="bgGrayBooker">
                <div
                  :class="[
                    getIsBdrUser()
                      ? 'nav-link text-left'
                      : 'nav-link text-left py-0',
                    textDark,
                  ]"
                  href
                >
                  <div class="d-inline">
                    <i class="icon-question" :class="textDark"></i>
                  </div>
                  <span class="item-name ml-2" :class="textDark">
                    <span class="title">{{ $t("lang.button.help") }}</span>
                  </span>
                </div>
              </li>
            </a>

            <!-- <router-link :class="hoverClassBooker" :to="'/login'">
  <li class="nav-item py-0 px-1 m-0" :style="bgGrayBooker">
    <div class="nav-link text-left" :class="isUserBilling ? 'billingClassMenu nav-link text-left' : textDark" href>
      <div class="d-inline" >
        <i class="icon-sign-out" :class="textDark"></i>
      </div>
      <span class="item-name ml-2" :class="textDark">
        <span class="title">{{ $t("lang.button.logout") }}</span>
      </span>
    </div>
  </li>
</router-link> -->
          </div>
          <!-- Footer inferior: legacy/booker (admin y client lo llevan en su layout) -->
          <li v-if="!isSidebarRedesign" class="sidebar-bottom-li">
            <div class="sidebar-bottom" :style="bgGrayBooker">
              <!-- <div class="sidebar-updated text-small" :class="textDark">
          {{ $t("lang.column.updated") }}: <small>{{ buildTimeFormatted }}</small>
        </div> -->
              <router-link
                :class="hoverClassBooker"
                :to="'/login'"
                class="btn btn-light"
              >
                <small class="title">{{ $t("lang.button.logout") }}</small>
              </router-link>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import {
  usersService,
  clientsService,
  targetsService,
  monitorService,
  adminService,
  workspaceService,
  opportunitiesService,
} from "@/_services";

import { tabsMixin } from "@/_mixins/";
import jQuery from "jquery";

import Modal from "@/components/Common/Modal.vue";
import SidebarClient from "@/views/SidebarClient.vue";
import SidebarBooker from "@/views/SidebarBooker.vue";
import SidebarIcon from "@/assets/icons/sidebar/SidebarIcon.vue";
import {
  resolveAdminSidebarIcon,
  resolveAdminOrphanSidebarIcon,
} from "@/assets/icons/sidebar/paths";
let $ = jQuery;

export default {
  created() {
    console.log(this.user);
    this.roleClient = this.user.role_id == 4;
    if (this.roleClient && !this.isClientSidebar) {
      this.$set(this.menu[0], "name", this.$t("lang.label.meeting"));
    }
    // if (this.user.role_id == 1) {
    //   this.getTotalNewClaims();
    // }

    this.CollapseNavOpen();
    if (this.user.role_id == 4) this.updateStatusOnboarding();
  },

  components: { Modal, SidebarClient, SidebarBooker, SidebarIcon },
  data() {
    var self = this;
    return {
      oliver_sale_id: "0",
      itemSelected: false,
      loadingStatusOnboarding: false,
      dataUsers: [],
      sincronized: 0,
      avatar: null,
      keyLinkedin: 1,
      roleClient: false,
      minlink: false,
      stopondemand: false,
      minondemand: false,
      agency_signed: true,
      menu: [
        {
          name: this.$t("lang.menu.reports"),
          linkTo: "/dashboard",
          event: "mousedown('/dashboard')",
          icon: "icon-dashboard",
          roles: [3, 4, 6, 8],
          team_roles: [1, 2, 3],
          afterTrialPeriodAvailable: false,
          id: "dashboard",
        },
        {
          name: this.$t("lang.menu.reports"),
          linkTo: "/reports",
          event: "mousedown('/dashboard')",
          icon: "icon-dashboard",
          roles: [1],
          team_roles: [1, 2, 3],
          showSubmenu: false,
          hasTasks: false,
          id: "reports",
          submenu: [
            {
              name: this.$t("lang.label.agency"),
              linkTo: "/dashboard/tabs/1",
              icon: "icon-caret-right1",
              hideTo2: ["isUserOperational"],
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              id: 1,
            },
            {
              name: "Meetings",
              linkTo: "/dashboard/tabs/8",
              icon: "icon-caret-right1",
              hideTo2: ["isUserOperational", "isUserSupport"],
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              id: 3,
            },
            {
              name: "Scheduled Emails",
              linkTo: "/dashboard/tabs/10",
              icon: "icon-caret-right1",
              hideTo: self.hasPermissions("isAgencyManager"),
              hideTo2: ["isUserOperational"],
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              id: 5,
            },
            {
              name: "Meeting / Client",
              linkTo: "/dashboard/tabs/22",
              icon: "icon-caret-right1",
              hideTo: self.hasPermissions("isAgencyManager"),
              hideTo2: ["isUserOperational"],
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              id: 8,
            },
            {
              name: "Report Credit",
              linkTo: "/dashboard/tabs/14",
              icon: "icon-caret-right1",
              hideTo: self.hasPermissions("isAgencyManager"),
              hideTo2: ["isUserOperational", "superAdmin"],
              roles: [6, 8],
              team_roles: [1, 2],
              id: 10,
            },
            // {
            //   name: 'Live Domain IP',
            //   linkTo: "/dashboard/tabs/18",
            //   icon: "icon-caret-right1",
            //   hideTo: self.hasPermissions('isAgencyManager'),
            //   hideTo2: ['isUserOperational'],
            //   roles: [1, 5, 6, 8],
            //   team_roles: [1, 2],
            //   id: 11,
            // },
            {
              name: "Metrics",
              linkTo: "/dashboard/tabs/21",
              icon: "icon-caret-right1",
              hideTo: self.hasPermissions("isAgencyManager"),
              hideTo2: ["isUserOperational"],
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              id: 12,
            },
          ],
        },
        {
          name: "Infrastructure",
          linkTo: "/allinfrastructure",
          event: "mousedown('/allinfrastructure')",
          icon: "icon-simplybuilt",
          roles: [1, 6, 8],
          team_roles: [1, 2],
          afterTrialPeriodAvailable: false,
          showSubmenu: false,
          hasTasks: false,
          id: "infrastructure",
          submenu: [
            {
              name: "Business Contacts",
              linkTo: "/dashboard/tabs/19",
              icon: "icon-caret-right1",
              hideTo: self.hasPermissions("isAgencyManager"),
              hideTo2: ["isUserOperational"],
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              id: 9,
            },
            {
              name: "Deleted domains",
              linkTo: "/allinfrastructure/5",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hideTo2: [
                "isUserAccountManager",
                "isUserOperational",
                "isUserSupport",
                "isUserAttendance",
                "isUserContable",
                "isUserBookerRecuiter",
              ],
            },
            {
              name: "Domains renewal",
              linkTo: "/allinfrastructure/6",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hideTo2: [
                "isUserAccountManager",
                "isUserOperational",
                "isUserSupport",
                "isUserAttendance",
                "isUserContable",
                "isUserBookerRecuiter",
              ],
              id: 5,
            },
            {
              name: "Invoice control",
              linkTo: "/allinfrastructure/4",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hideTo2: [
                "isUserAccountManager",
                "isUserOperational",
                "isUserSupport",
                "isUserAttendance",
                "isUserContable",
                "isUserBookerRecuiter",
              ],
              id: 4,
            },
            {
              name: "Mailboxes",
              linkTo: "/dashboard/tabs/11",
              icon: "icon-caret-right1",
              hideTo: self.hasPermissions("isAgencyManager"),
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hideTo2: [
                "isUserOperational",
                "isUserSupport",
                "isUserAttendance",
                "isUserContable",
                "isUserBookerRecuiter",
              ],
              id: 6,
            },
            {
              name: "Phone Directory",
              linkTo: "/dashboard/tabs/28",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hideTo2: [
                "isUserAccountManager",
                "isUserOperational",
                "isUserSupport",
                "isUserAttendance",
                "isUserContable",
                "isUserBookerRecuiter",
              ],
              id: 15,
            },
            {
              name: "Warmup Data",
              linkTo: "/smartleadstats",
              icon: "icon-caret-right1",
              hideTo: self.hasPermissions("isAgencyManager"),
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hideTo2: [
                "isUserAccountManager",
                "isUserOperational",
                "isUserSupport",
                "isUserAttendance",
                "isUserContable",
                "isUserBookerRecuiter",
              ],
              id: 7,
            },
            {
              name: "Data Monitoring",
              linkTo: "/data-monitoring-stats",
              icon: "icon-caret-right1",
              hideTo: self.hasPermissions("isAgencyManager"),
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hideTo2: [
                "isUserAccountManager",
                "isUserOperational",
                "isUserSupport",
                "isUserAttendance",
                "isUserContable",
                "isUserBookerRecuiter",
              ],
              id: 29,
            },
            {
              name: "Workspaces",
              linkTo: "/dashboard/tabs/3",
              icon: "icon-caret-right1",
              hideTo: self.hasPermissions("isAgencyManager"),
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              id: 8,
            },
          ],
        },
        {
          name: "Bookers",
          linkTo: "/allbdr",
          event: "mousedown('/allbdr')",
          icon: "icon-handshake-o",
          roles: [1, 6, 8, 9],
          team_roles: [1, 2],
          afterTrialPeriodAvailable: false,
          showSubmenu: false,
          hasTasks: false,
          id: "bdr",
          submenu: [
            {
              name: "Booker Results",
              linkTo: "/allbdr/1",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8, 9],
              team_roles: [1, 2],
              id: 1,
            },
            {
              name: "Tasks",
              linkTo: "/allbdr/2",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8, 9],
              team_roles: [1, 2],
              id: 2,
            },
            {
              name: "New Tasks",
              linkTo: "/allbdr/8",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8, 9],
              team_roles: [1, 2],
              id: 9,
            },
            {
              name: "Email Answers",
              linkTo: "/allbdr/9",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8, 9],
              team_roles: [1, 2],
              id: 10,
            },
            {
              name: "Overview",
              linkTo: "/allbdr/3",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8, 9],
              team_roles: [1, 2],
              id: 3,
            },
            {
              name: "Ranking",
              linkTo: "/allbdr/5",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8, 9],
              team_roles: [1, 2],
              id: 5,
            },
            {
              name: "Timing",
              linkTo: "/allbdr/6",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8, 9],
              team_roles: [1, 2],
              id: 6,
            },
            {
              name: "Daily",
              linkTo: "/allbdr/7",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8, 9],
              team_roles: [1, 2],
              id: 7,
            },
            {
              name: "Calls",
              linkTo: "/bookers-calls",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1, 2, 5, 6, 8, 9],
              team_roles: [1, 2],
              id: 8,
            },
            {
              name: "Payments",
              linkTo: "/allbdr/10",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1],
              team_roles: [1, 2],
              id: 10,
            },
            {
              name: "Pipe",
              linkTo: "/allbdr/11",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1],
              team_roles: [1, 2],
              id: 11,
            },
            {
              name: "Booker Stats",
              linkTo: "/allbdr/17",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1],
              team_roles: [1, 2],
              id: 12,
            },
            {
              name: "Commission",
              linkTo: "/booker-commission",
              icon: "icon-caret-right1",
              roles: [1],
              team_roles: [1, 2],
              id: 13,
            },
            {
              name: "Consistency",
              linkTo: "/allbdr/12",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1],
              team_roles: [1, 2],
              id: 14,
            },
            {
              name: "Call Statistics",
              linkTo: "/allbdr/13",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1],
              team_roles: [1, 2],
              id: 15,
            },
            {
              name: "Booker Allocation",
              linkTo: "/allbdr/14",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1],
              team_roles: [1, 2],
              id: 16,
            },
            {
              name: "Manager Pools",
              linkTo: "/allbdr/16",
              hideTo2: ["isUserSupport"],
              icon: "icon-caret-right1",
              roles: [1],
              hideTo: self.hasPermissions("isBookerManager"),
              team_roles: [1, 2],
              id: 16,
            },
          ],
        },
        {
          name: "Copywriting",
          linkTo: "/syncemails/18",
          event: "mousedown('/syncemails/18')",
          icon: "icon-wechat",
          roles: [1, 6, 8],
          team_roles: [1, 2],
          afterTrialPeriodAvailable: false,
          showSubmenu: false,
          hasCounter: true,
          hasTasks: false,
          count: false,
          id: "targetNoteChat",
          submenu: [
            {
              name: "Open L1",
              linkTo: "/syncemails/18/1",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hideTo: "isUserOliverSale",
              hasCounter: true,
              count: false,
              id: 1,
            },
            {
              name: "Open L2",
              linkTo: "/syncemails/18/2",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 2,
            },
          ],
        },
        {
          name: "Configuration",
          linkTo: "/syncemails/",
          event: "mousedown('/syncemails')",
          icon: "icon-search",
          roles: [1, 6, 8],
          team_roles: [1, 2],
          afterTrialPeriodAvailable: false,
          showSubmenu: false,
          hasTasks: false,
          id: "configuration",
          submenu: [
            {
              name: "Mailboxes first sync",
              linkTo: "/syncemails/1",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 1,
            },
            {
              name: "Mailboxes Re-sync",
              linkTo: "/syncemails/2",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 2,
            },
            {
              name: "Domains to buy",
              linkTo: "/syncemails/12",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 7,
            },
            {
              name: "Mailbox creation",
              linkTo: "/syncemails/5",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 4,
            },
            {
              name: "Blocked mailboxes",
              linkTo: "/syncemails/3",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 3,
            },
            {
              name: "Domain Config",
              linkTo: "/syncemails/8",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 6,
            },
            {
              name: "Missing campaign data",
              linkTo: "/syncemails/13",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 8,
            },
            {
              name: "High margin campaigns",
              linkTo: "/allperformances/32",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 5,
            },
            {
              name: "Warmup",
              linkTo: "/syncemails/16",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 9,
            },
            {
              name: "Missing campaign team",
              linkTo: "/syncemails/23",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 13,
            },
            {
              name: "Not prospecting campaigns",
              linkTo: "/syncemails/24",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 14,
            },
            {
              name: "Missing client AM",
              linkTo: "/syncemails/26",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 16,
            },
            {
              name: "Phone lookup",
              linkTo: "/syncemails/28",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 18,
            },
            {
              name: "Missing campaign mailboxes",
              linkTo: "/orders_warnings/missing",
              event: "mousedown('/oliver_sales_dashboard')",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              afterTrialPeriodAvailable: false,
              hasCounter: true,
              showSubmenu: false,
              count: false,
              id: 19,
            },
            {
              name: "Reported campaigns",
              linkTo: "/orders_warnings/reported",
              event: "mousedown('/oliver_sales_dashboard')",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              afterTrialPeriodAvailable: false,
              hasCounter: true,
              showSubmenu: false,
              count: false,
              id: 21,
            },
            {
              name: "Critical supply",
              linkTo: "/syncemails/14/1",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 22,
            },
            {
              name: "Import Error",
              linkTo: "/import-error",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 23,
            },
          ],
        },
        {
          name: "Account Management",
          linkTo: "/oliver_sales_dashboard",
          event: "mousedown('/oliver_sales_dashboard')",
          icon: "icon-group-outline",
          roles: [1, 6, 8],
          team_roles: [1, 2],
          afterTrialPeriodAvailable: false,
          showSubmenu: false,
          id: "sale_dashboard",
          submenu: [
            // {
            //   name: "Team Global View",
            //   linkTo: "/team-global-view",
            //   icon: "icon-caret-right1",
            //   roles: [1, 5, 6, 8],
            //   team_roles: [1, 2],
            // },
            {
              name: "Monthly metrics",
              linkTo: "/oliver_sales_dashboard/1",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
            },
            {
              name: "Global metrics",
              linkTo: "/oliver_sales_dashboard/2",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
            },
            {
              name: "Ranking",
              linkTo: "/oliver_sales_dashboard/3",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
            },
            {
              name: "Actions",
              linkTo: "/oliver_sales_dashboard/4",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
            },
            {
              name: "Team",
              linkTo: "/oliver_sales_dashboard/5",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
            },
            {
              name: "Achievements",
              linkTo: "/oliver_sales_dashboard/6",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
            },
            {
              name: "At-Risk Accounts",
              linkTo: "/oliver_sales_dashboard/7",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
            },
            {
              name: "Launchings",
              linkTo: "/client-launchings",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
            },
          ],
        },
        {
          name: this.$t("lang.menu.activity"),
          linkTo: "/activity",
          event: "mousedown('/activity')",
          icon: "fa-solid fa-chart-line",
          roles: [1, 4, 3],
          team_roles: [1, 2, 3],
          afterTrialPeriodAvailable: false,
        },

        {
          name: this.$t("lang.orders.orders"),
          linkTo: "/orders",
          event: "mousedown('/orders')",
          icon: "icon-barcode",
          roles: [4, 3, 5, 6],
          afterTrialPeriodAvailable: false,
        },
        {
          name: this.$t("lang.orders.orders"),
          linkTo: "/orders_details",
          event: "mousedown('/orders')",
          icon: "icon-barcode",
          roles: [1],
          afterTrialPeriodAvailable: false,
          showSubmenu: false,
          count: false,
          id: "orders",
          submenu: [
            {
              name: "COM",
              linkTo: "/allperformances/21",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 3,
            },
            {
              name: "WAC",
              linkTo: "/allperformances/25",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              team_roles: [1, 2],
              hasCounter: true,
              count: false,
              id: 2,
            },
            {
              name: this.$t("lang.orders.orders"),
              linkTo: "/orders",
              event: "mousedown('/orders')",
              icon: "icon-caret-right1",
              roles: [1],
              showSubmenu: false,
              hasCounter: false,
              count: false,
              id: 4,
            },
            {
              name: "Bookers France",
              event: "mousedown('/orders')",
              linkTo: "/orders-by-lang/1",
              icon: "icon-caret-right1",
              roles: [1],
              hasCounter: false,
              count: false,
              id: 5,
            },
            {
              name: "Bookers English",
              linkTo: "/orders-by-lang/2",
              icon: "icon-caret-right1",
              roles: [1],
              hasCounter: false,
              count: false,
              id: 6,
            },
            {
              name: "Bookers Italy",
              linkTo: "/orders-by-lang/4",
              icon: "icon-caret-right1",
              roles: [1],
              hasCounter: false,
              count: false,
              id: 7,
            },
            {
              name: "Bookers Spain",
              linkTo: "/orders-by-lang/3",
              icon: "icon-caret-right1",
              roles: [1],
              hasCounter: false,
              count: false,
              id: 8,
            },
          ],
        },
        {
          name: "Revenue",
          linkTo: "/revenue",
          event: "mousedown('/revenue')",
          icon: "icon-money",
          roles: [1],
          afterTrialPeriodAvailable: false,
          showSubmenu: false,
          id: "revenue",
          submenu: [
            {
              name: "Revenue / Client",
              linkTo: "/dashboard/tabs/29",
              event: "mousedown('/dashboard/tabs/29')",
              icon: "icon-caret-right1",
              hideTo: self.hasPermissions("isAgencyManager"),
              hideTo2: [
                "isUserAccountManager",
                "isUserOperational",
                "isUserSupport",
                "isUserAttendance",
                "isUserContable",
                "isUserBookerRecuiter",
              ],
              roles: [1],
              id: 1,
            },
            {
              name: "Revenue Workflow",
              linkTo: "/usages",
              event: "mousedown('/usages')",
              icon: "icon-caret-right1",
              roles: [1],
              id: 2,
              hideTo2: ["isUserAccountManager"],
            },
            {
              name: "Invoices",
              linkTo: "/invoices_admin",
              icon: "icon-caret-right1",
              roles: [1],
              id: 3,
            },
            {
              name: "Credits",
              linkTo: "/dashboard/tabs/14",
              icon: "icon-caret-right1",
              hideTo: self.hasPermissions("isAgencyManager"),
              hideTo2: ["isUserOperational"],
              roles: [1],
              id: 4,
            },
            {
              name: "Credit Notes",
              linkTo: "/credit-notes",
              icon: "icon-caret-right1",
              hideTo: self.hasPermissions("isAgencyManager"),
              hideTo2: ["isUserOperational"],
              roles: [1],
              id: 4,
            },
            {
              name: "Recovering",
              linkTo: "/invoices_recovering",
              event: "mousedown('/invoices_recovering')",
              icon: "icon-caret-right1",
              hideTo: self.hasPermissions("isAgencyManager"),
              hideTo2: [
                "isUserOperational",
                "isUserSupport",
                "isUserAttendance",
                "isUserContable",
                "isUserBookerRecuiter",
              ],
              roles: [1],
              id: 5,
            },
            {
              name: "Suscribers",
              linkTo: "/client-subscribers",
              event: "mousedown('/client-suscribers')",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              hideTo: self.hasPermissions("isReferal"),
              id: 6,
            },
            {
              name: "Payment Methods",
              linkTo: "/payment-methods-client",
              event: "mousedown('/payment-methods-client')",
              icon: "icon-caret-right1",
              roles: [1],
              id: 7,
            },
          ],
        },
        {
          name: this.$t("lang.menu.contacts"),
          linkTo: "/businesses",
          event: "mousedown('/businesses')",
          icon: "icon-users",
          roles: [1, 2, 3, 4],
          team_roles: [1, 3],
          afterTrialPeriodAvailable: false,
        },
        {
          name: "Attendance",
          linkTo: "/attendance",
          event: "mousedown('/oliver_sales_dashboard')",
          icon: "icon-group-outline",
          roles: [1],
          team_roles: [1, 2],
          afterTrialPeriodAvailable: false,
          showSubmenu: false,
          id: "attendance",
          submenu: [
            {
              name: "Attendance Desk", //this.$t("lang.menu.meeting_att"),
              linkTo: "/meeting-attendance",
              event: "mousedown('/meeting-attendance')",
              icon: "icon-caret-right1",
              roles: [1],
              team_roles: [1, 2],
              afterTrialPeriodAvailable: false,
            },
            {
              name: "Attendance Stats",
              linkTo: "/attendance-stats",
              event: "mousedown('/attendance-stats')",
              icon: "icon-caret-right1",
              roles: [1],
              team_roles: [1, 2],
              afterTrialPeriodAvailable: false,
            },
            {
              name: "Status Processed",
              linkTo: "/meetings-status-processed",
              event: "mousedown('/meetings-status-processed')",
              icon: "icon-caret-right1",
              roles: [1],
              team_roles: [1, 2],
              afterTrialPeriodAvailable: false,
            },
          ],
        },
        {
          name: "Clients",
          linkTo: "/client",
          event: "mousedown('/client')",
          icon: "icon-briefcase2",
          roles: [1, 5, 6, 7, 8],
          afterTrialPeriodAvailable: false,
          showSubmenu: false,
          id: "clients",
          submenu: [
            {
              name: "All Clients",
              linkTo: "/clients",
              event: "mousedown('/clients')",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 7, 8],
            },
            {
              name: "Cold Call Clients",
              linkTo: "/client-subscriptions",
              event: "mousedown('/client-subscriptions')",
              icon: "icon-caret-right1",
              roles: [1, 5, 6, 8],
              hideTo: self.hasPermissions("isReferal"),
            },
            {
              name: "Client Stats",
              linkTo: "/client-stats",
              event: "mousedown('/client-stats')",
              icon: "icon-caret-right1",
              roles: [1],
              hideTo: self.hasPermissions("isReferal"),
            },
            {
              name: "Client Docs",
              linkTo: "/client-docs",
              event: "mousedown('/client-docs')",
              icon: "icon-caret-right1",
              roles: [1],
              hideTo: self.hasPermissions("isReferal"),
            },
          ],
        },
        {
          name: "AI Meetings Replay",
          linkTo: "/ai-meetings-replay",
          event: "mousedown('/ai-meetings-replay')",
          icon: "icon-play",
          roles: [1],
          afterTrialPeriodAvailable: false,
        },
        {
          name: "Claims",
          linkTo: "/link-claims",
          event: "mousedown('/link-claims')",
          icon: "icon-exclamation-circle",
          roles: [1],
          team_roles: [1, 2],
          afterTrialPeriodAvailable: false,
          // hasCounter: true,
          // count: false,
          id: "claims",
        },
        {
          name: "Affiliates Comissions",
          linkTo: "/Affiliation",
          event: "mousedown('/Affiliation')",
          icon: "icon-menu",
          roles: [1, 5, 7],
          team_roles: [],
          afterTrialPeriodAvailable: false,
          hideTo2: ["isUserAccountManager"],
        },
        {
          name: this.$t("lang.menu.calendars"),
          linkTo: "/calendars",
          event: "mousedown('/calendars')",
          icon: "icon-calendar",
          roles: [1, 6],
          afterTrialPeriodAvailable: false,
        },
        {
          name: "Camp. health",
          linkTo: "/campaigns-health",
          event: "mousedown('/campaigns-health')",
          icon: "fa fa-stethoscope",
          roles: [1],
          afterTrialPeriodAvailable: false,
        },
        {
          name: this.$t("lang.menu.opportunities"),
          linkTo: "/opportunities",
          event: "mousedown('/opportunities')",
          icon: "icon-headset_mic",
          roles: [5, 6],
          team_roles: [1, 2, 3],
          afterTrialPeriodAvailable: false,
        },
        {
          name: "Master Inbox",
          linkTo: "/emails",
          event: "mousedown('/emails')",
          icon: "icon-envelope-o",
          roles: [1, 8],
          team_roles: [2],
        },
        {
          name: "Audit captcha",
          linkTo: "/antispam-audit",
          event: "mousedown('/antispam-audit')",
          icon: "icon-check",
          roles: [1, 8],
        },
        {
          name: this.$t("lang.menu.usages"),
          linkTo: "/usages",
          event: "mousedown('/usages')",
          icon: "icon-money",
          roles: [1],
        },
        {
          name: "Revenue / Client",
          linkTo: "/dashboard/tabs/29",
          event: "mousedown('/dashboard/tabs/29')",
          icon: "fa-solid fa-users",
          hideTo: self.hasPermissions("isAgencyManager"),
          hideTo2: [
            "isUserAccountManager",
            "isUserOperational",
            "isUserSupport",
            "isUserAttendance",
            "isUserContable",
            "isUserBookerRecuiter",
          ],
          roles: [1],
        },
        {
          name: this.$t("lang.menu.users"),
          linkTo: "/users",
          event: "mousedown('/users')",
          icon: "icon-person",
          roles: [1, 5, 6],
        },
      ],
    };
  },
  mounted() {},

  mixins: [tabsMixin],

  computed: {
    /** Fecha/hora del build (inyectada en vue.config.js). Formato: dd/mm/yyyy - HH:mm */
    buildTimeFormatted() {
      const d = new Date();
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year} - 18:00`;
    },
    linkSubmenu() {
      return (submenu) => {
        submenu.forEach((el) => {
          el.hideItem = false;

          if (el.hideTo2 && Array.isArray(el.hideTo2)) {
            const itemsToCheck = el.hideTo2;
            itemsToCheck.forEach((item) => {
              // Primero verificar si existe como getter/computed (ej: isUserOperational)
              if (typeof this[item] !== "undefined") {
                if (this[item]) {
                  el.hideItem = true;
                }
              }
              // Si no existe como propiedad, intentar con hasPermissions (ej: superAdmin)
              else if (this.hasPermissions) {
                try {
                  if (this.hasPermissions(item)) {
                    el.hideItem = true;
                  }
                } catch (e) {
                  // El permiso no existe, ignorar
                }
              }
            });
          }

          if (el.hideTo) {
            // Verificar si es un boolean ya evaluado
            if (typeof el.hideTo === "boolean") {
              if (el.hideTo) {
                el.hideItem = true;
              }
            }
            // Si es string, verificar como getter primero
            else if (typeof el.hideTo === "string") {
              if (typeof this[el.hideTo] !== "undefined") {
                if (this[el.hideTo]) {
                  el.hideItem = true;
                }
              }
              // Si no existe como getter, intentar con hasPermissions
              else if (this.hasPermissions) {
                try {
                  if (this.hasPermissions(el.hideTo)) {
                    el.hideItem = true;
                  }
                } catch (e) {
                  // El permiso no existe, ignorar
                }
              }
            }
          }
        });

        return submenu.filter((el) => el.hideItem != true);
      };
    },

    specialFilterMenu() {
      return (menu) => {
        let showItem = true;

        if (menu.hideTo2 && Array.isArray(menu.hideTo2)) {
          const itemsToCheck = menu.hideTo2;

          itemsToCheck.forEach((item) => {
            // Primero verificar si existe como getter/computed (ej: isUserOperational)
            if (typeof this[item] !== "undefined") {
              if (this[item]) {
                showItem = false;
              }
            }
            // Si no existe como propiedad, intentar con hasPermissions (ej: superAdmin)
            else if (this.hasPermissions) {
              try {
                if (this.hasPermissions(item)) {
                  showItem = false;
                }
              } catch (e) {
                // El permiso no existe, ignorar
              }
            }
          });
        }

        return showItem;
      };
    },

    isAdminSidebarRedesign() {
      return this.user && Number(this.user.role_id) === 1;
    },

    isClientSidebar() {
      if (!this.user) {
        return false;
      }
      const roleId = Number(this.user.role_id);
      return roleId === 3 || roleId === 4;
    },

    isBookerSidebar() {
      if (!this.user) {
        return false;
      }
      return (
        Number(this.user.role_id) === 2 && Number(this.user.team_role_id) === 2
      );
    },

    isSidebarRedesign() {
      return (
        this.isAdminSidebarRedesign ||
        this.isClientSidebar ||
        this.isBookerSidebar
      );
    },

    adminShowSettings() {
      return !(
        this.isUserOperational ||
        this.isUserContable ||
        this.isUserAttendance
      );
    },

    adminShowHelp() {
      return !(
        (this.user.team_role_id !== undefined && this.user.team_role_id == 3) ||
        this.user.role_id == 4 ||
        this.isUserOperational ||
        this.isUserContable ||
        this.isUserBookerRecuiter ||
        this.isUserAttendance
      );
    },

    // DEFINO LOS SUBCONJUNTOS DE LOS ITEMS
    adminMenuFamilies() {
      return [
        {
          key: "prospection",
          label: "Prospection",
          entries: [
            { linkTo: "/activity" },
            { linkTo: "/opportunities" },
            { menuId: "orders", submenuOrder: [3, 2, 4, 5, 6, 7, 8] },
            { menuId: "targetNoteChat", submenuOrder: [1, 2] },
            { linkTo: "/emails" },
            { linkTo: "/calendars" },
            { linkTo: "/businesses" },
            { menuId: "attendance" },
            { linkTo: "/ai-meetings-replay" },
            { linkTo: "/campaigns-health" },
          ],
        },
        {
          key: "infrastructure",
          label: "Infrastructure technique",
          entries: [
            { menuId: "infrastructure" },
            {
              menuId: "configuration",
              submenuOrder: [
                1, 2, 7, 4, 3, 6, 8, 5, 9, 13, 14, 16, 18, 19, 21, 22, 23,
              ],
            },
          ],
        },
        {
          key: "equipes",
          label: "Équipes",
          entries: [{ menuId: "bdr" }, { linkTo: "/users" }],
        },
        {
          key: "clients",
          label: "Clients & Revenus",
          entries: [
            { menuId: "clients" },
            { menuId: "sale_dashboard" },
            { menuId: "revenue" },
            { linkTo: "/Affiliation" },
            { menuId: "claims" },
          ],
        },
        {
          key: "pilotage",
          label: "Pilotage & Système",
          entries: [
            { menuId: "reports", submenuOrder: [1, 3, 5, 8, 12] },
            { type: "settings" },
          ],
        },
      ];
    },

    adminRegisteredMenuIds() {
      const ids = new Set();
      this.adminMenuFamilies.forEach((family) => {
        family.entries.forEach((entry) => {
          if (entry.menuId) {
            ids.add(entry.menuId);
          }
        });
      });
      return ids;
    },

    adminRegisteredLinkTos() {
      const linkTos = new Set();
      this.adminMenuFamilies.forEach((family) => {
        family.entries.forEach((entry) => {
          if (entry.linkTo) {
            linkTos.add(entry.linkTo);
          }
          if (entry.menuId) {
            const parent = this.menu.find((m) => m.id === entry.menuId);
            if (parent && parent.submenu) {
              parent.submenu.forEach((sub) => {
                if (sub.linkTo) {
                  linkTos.add(sub.linkTo);
                }
              });
            }
          }
        });
      });
      return linkTos;
    },

    adminOrphanMenuIndices() {
      if (!this.isAdminSidebarRedesign) {
        return [];
      }
      const indices = [];
      this.menu.forEach((link, index) => {
        if (this.isAdminMenuRegistered(link)) {
          return;
        }
        if (this.checkRol(index) && this.specialFilterMenu(link)) {
          indices.push(index);
        }
      });
      return indices;
    },

    logo() {
      if (this.isBookerSidebar && !this.isSidebarRedesign) {
        return require("@/assets/images/booker/Merci_hubert_by_oliverlist.png");
      }

      return require("@/assets/images/oliverlist_booker_menu.png");
    },

    hoverClassBooker() {
      return "hover-booker active-booker";
    },

    navBooker() {
      if (this.user.role_id == 2 && this.user.team_role_id == 2) {
        return "nav-booker";
      }
      return "";
    },

    bgGrayBooker() {
      if (this.isSidebarRedesign) {
        return "";
      }
      return "background: #E6E7F4"; //E6E7F4
    },
    textDark() {
      return "text-dark";
    },
    colorIcon() {
      return "color: #7A7B9E";
    },
    user() {
      return this.$store.state.authentication.user;
    },
    ...mapGetters("onboarding", ["getStatusOnboarding"]),
    ...mapGetters("authentication", [
      "isUserOliverSale",
      "isSaleOrAccountExecutive",
    ]),
    computedStatusOnboarding() {
      if (this.hasPermissions("billing")) {
        return this.statusOnboarding.filter((el) => el.value === false).length;
      } else if (this.hasPermissions("sale")) {
        const consideredStates = ["emailSincronized", "avatar"];

        return this.statusOnboarding
          .filter((e) => consideredStates.includes(e.name))
          .filter((el) => el.value === false).length;
      }
    },
    toastNotificationData() {
      return this.$store.state.authentication.toastNotificationData;
    },
    ...mapState({
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      user: (state) => state.authentication.user,
      statusOnboarding: (state) => state.onboarding.statusOnboarding,
    }),
    notifications() {
      return this.$store.state.authentication.notifications;
    },
    vueAppEnv() {
      return process.env.VUE_APP_ENV;
    },
    isUserAccountManager() {
      return this.user.role_id == 1 && this.user.user_constraint_id == 2;
    },
    isUserOperational() {
      return this.user.role_id == 1 && this.user.user_constraint_id == 1;
    },
    isUserSupport() {
      return this.user.role_id == 1 && this.user.user_constraint_id == 6;
    },
    isUserAttendance() {
      return this.user.role_id == 1 && this.user.user_constraint_id == 7;
    },
    isUserContable() {
      return this.user.role_id == 1 && this.user.user_constraint_id == 4;
    },
    isUserBookerRecuiter() {
      return this.user.role_id == 1 && this.user.user_constraint_id == 5;
    },
    isUserBilling() {
      return this.user.role_id == 4 && this.user.team_role_id == 3;
    },
    isBookerManager() {
      return this.user.role_id == 9;
    },
    isBdrUser() {
      return (status) => {
        if (status) {
          if (
            this.user.team_role_id == 2 &&
            this.user.role_id == 2 &&
            status.includes(this.user.booker.status)
          ) {
            return true;
          }
        } else {
          if (this.user.team_role_id == 2 && this.user.role_id == 2) {
            return true;
          }
        }
        return false;
      };
    },
  },
  methods: {
    ...mapMutations("sidebar", {
      CollapseNav: "toggleNav",
      CollapseNavOpen: "toggleNavOpen",
      CollapseNavClose: "toggleNavClose",
      NavigationClicked: "navigationClicked",
    }),
    ...mapActions("onboarding", {
      setStatusOnboarding: "setStatusOnboarding",
    }),
    getIsBdrUser() {
      if (this.user.team_role_id == 2 && this.user.role_id == 2) {
        this.bdr_user_id = this.user.id;
        return true;
      } else {
        return false;
      }
    },

    adminSidebarIconName(entry) {
      return resolveAdminSidebarIcon(entry);
    },

    adminOrphanSidebarIconName(link) {
      return resolveAdminOrphanSidebarIcon(link);
    },

    resolveAdminMenuLink(entry) {
      if (!entry || entry.type === "settings") {
        return null;
      }
      if (entry.menuId) {
        return this.menu.find((m) => m.id === entry.menuId) || null;
      }
      if (entry.linkTo) {
        return this.menu.find((m) => m.linkTo === entry.linkTo) || null;
      }
      return null;
    },

    isAdminMenuRegistered(link) {
      if (!link) {
        return false;
      }
      if (link.id && this.adminRegisteredMenuIds.has(link.id)) {
        return true;
      }
      if (link.linkTo && this.adminRegisteredLinkTos.has(link.linkTo)) {
        return true;
      }
      return false;
    },

    isAdminMenuLinkVisible(link) {
      const index = this.menu.findIndex(
        (m) =>
          m === link ||
          (link.id && m.id === link.id) ||
          (!link.id &&
            m.linkTo === link.linkTo &&
            !m.submenu &&
            !link.submenu) ||
          (link.id && m.id === link.id)
      );
      if (index === -1) {
        return false;
      }
      return this.checkRol(index) && this.specialFilterMenu(link);
    },

    adminFamilyHasVisibleEntries(family) {
      return family.entries.some((entry) => {
        if (entry.type === "settings") {
          return this.adminShowSettings;
        }
        const link = this.resolveAdminMenuLink(entry);
        return link && this.isAdminMenuLinkVisible(link);
      });
    },

    adminOrderedSubmenu(link, orderIds) {
      const items = this.linkSubmenu(link.submenu);
      if (!orderIds || !orderIds.length) {
        return items;
      }
      const ordered = [];
      orderIds.forEach((id) => {
        const found = items.find((s) => s.id === id);
        if (found) {
          ordered.push(found);
        }
      });
      items.forEach((s) => {
        if (!ordered.includes(s)) {
          ordered.push(s);
        }
      });
      return ordered;
    },

    adminItemMousedown(link, index) {
      const idx =
        index !== undefined
          ? index
          : this.menu.findIndex((m) => m.linkTo === link.linkTo && !m.submenu);
      if (idx === -1) {
        this.mousedown(link.linkTo);
        return;
      }
      if (this.checkPlan(idx)) {
        this.mousedown(link.linkTo);
      } else {
        this.restrictedAccess();
      }
    },

    adminSubmenuMousedown(parentLink, sublink, parentIndex) {
      const idx =
        parentIndex !== undefined
          ? parentIndex
          : this.menu.findIndex(
              (m) =>
                (parentLink.id && m.id === parentLink.id) ||
                m.linkTo === parentLink.linkTo
            );
      if (idx === -1) {
        this.mousedown(sublink.linkTo);
        return;
      }
      if (this.checkPlan(idx)) {
        this.mousedown(sublink.linkTo);
      } else {
        this.restrictedAccess();
      }
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },

    getContactSupplyTotals() {
      if (this.isUserOliverSale) {
        this.oliver_sale_id = this.user.id;
      }
      //this.getTargetContactSupply('count', 14, this.oliver_sale_id, 'configuration', 1);
      // this.getTargetContactSupply('count', 14, this.oliver_sale_id, 'orders', 2);
    },

    getTotalNewClaims() {
      adminService.getTotalNewClaims().then((response) => {
        const total = response.total;
        this.menu.find((el) => el.id == "claims").count = total;
      });
    },

    openCloseSubmenu(id, all = false) {
      if (all) {
        this.menu.forEach((el) => {
          if (el.submenu) {
            el.showSubmenu = false;
          }
        });

        return false;
      }

      if (!id) {
        return false;
      }

      const menuItem = this.menu.find((el) => el.id == id);
      if (!menuItem || !menuItem.submenu) {
        return false;
      }

      if (id == "configuration" || id == "performances") {
        menuItem.submenu.forEach((e) => {
          e.count = false;
        });
      }

      menuItem.showSubmenu = !menuItem.showSubmenu;

      if (id == "targetNoteChat" && menuItem.showSubmenu) {
        this.getTargetNoteChatTotal();
      }

      if (id == "configuration" && menuItem.showSubmenu) {
        this.getConfigurationTotals();
      }

      if (id == "orders" && menuItem.showSubmenu) {
        this.getPerformancesTotals();
        this.getContactSupplyTotals();
      }
    },

    getTargetNoteChatTotal() {
      if (this.isUserOliverSale) {
        this.oliver_sale_id = this.user.id;
      }
      this.getTargetNotes(
        "count",
        "18",
        2,
        this.oliver_sale_id,
        "targetNoteChat",
        2
      );

      if (!this.isUserOliverSale) {
        this.getTargetNotes(
          "count",
          "18",
          1,
          this.oliver_sale_id,
          "targetNoteChat",
          1
        );
      }
    },

    getPerformancesTotals() {
      if (this.isUserOliverSale) {
        this.oliver_sale_id = this.user.id;
      }

      //this.getTargetToProfitability('count', 19, 'LowCashableMargin', this.oliver_sale_id, 'orders', 1);
      //this.getTargetToProfitability('count', 20, 'LowOperatingMargin', this.oliver_sale_id, 'orders', 2);
      this.getTargetToProfitability(
        "count",
        21,
        "CriticalOperatingMargin",
        this.oliver_sale_id,
        "orders",
        3
      );
      //this.getTargetToProfitability('count', 32, 'HomCashableMargin', this.oliver_sale_id, 'orders', 5);
      // this.getTotalOrderImportedError('count', null, this.oliver_sale_id, 'configuration', 9)
      this.getCountWac("count", 25, this.oliver_sale_id, "orders", 2);
    },

    async getTotalOrderImportedError(
      count,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      let totalCount = 0;
      await targetsService.getTargetImportError(true).then((res) => {
        console.log(res);
        totalCount = res.total;
      });
      console.log("totalCount", totalCount);
      console.log(this.menu);
      this.menu
        .find((el) => el.id == menu)
        .submenu.find((el) => el.id == submenuId).count = totalCount
        ? totalCount
        : "0";
      this.updateStatusMenu("orders");
    },

    getConfigurationTotals() {
      this.getEmailSyncList("count", 1, 0, "configuration", 1);
      this.getEmailSyncList("count", 2, 0, "configuration", 2);
      this.getEmailSyncList("count", 3, 0, "configuration", 3);
      this.getEmailSyncList("count", 5, 0, "configuration", 4);
      this.getEmailSyncList("count", 6, 0, "configuration", 5);
      this.getCalendarDomains("configuration", 6);
      this.getDomainsToBuy("count", 12, 0, "configuration", 7);
      this.getTargetMissingData("count", 13, 0, "configuration", 8);
      this.getOwarmStats("count", 16, 0, "configuration", 9);
      this.getCommercialWithoutEmailsTotal("count", 17, 0, "configuration", 10);
      //this.getTargetListNotesTotal("count", 18, 0, 'configuration', 11);
      this.getEmailsConfigSmtp("count", 22, 0, "configuration", 12);
      this.getClientWithoutOliverSales("count", 23, 0, "configuration", 13);
      this.getNotProspectingSales("count", 24, 0, "configuration", 14);
      this.getClientAttribution("count", 26, 0, "configuration", 16);
      this.getSalesBurnedDomains("count", 27, 0, "configuration", 17);
      this.getPhoneLookup("count", 28, 0, "configuration", 18);
      this.getOrderWarning("missing", "configuration", 19);
      this.getOrderWarning("unverified", "configuration", 20);
      this.getOrderWarning("reported", "configuration", 21);
      this.getMicrosoftLicences("count", 25, 0, "configuration", 25);
      this.getTotalOrderImportedError(
        "count",
        null,
        this.oliver_sale_id,
        "configuration",
        23
      );
      this.getTargetContactSupply(
        "count",
        14,
        this.oliver_sale_id,
        "configuration",
        22
      );
    },

    openModal() {
      this.$modal.show("support");
    },
    async updateStatusOnboarding() {
      // Same source of truth as PreparingApp (Onboarding.vue): refresh user so `switches` is current,
      // then combine switches.calendar with Nylas user sync (see getData).
      try {
        await this.$store.dispatch("authentication/refreshToken");
      } catch (e) {
        return;
      }

      const requireBlacklist =
        this.user.require_blacklist == "1" ? true : false;
      if (requireBlacklist) {
        const item = {
          name: "blacklist",
          value: true,
        };
        this.setStatusOnboarding(item);
      } else {
        //get blacklist status
        await this.getBlacklist();
      }

      const itemEmail = {
        name: "emailSincronized",
        value: this.sincronized == this.dataUsers.length ? true : false,
      };
      this.setStatusOnboarding(itemEmail);
      // get Email Sicronized status
      const responseEmail = await this.getData();
      // get user avatar status
      const item = {
        name: "avatar",
        value: this.user.avatar ? true : false,
      };
      this.setStatusOnboarding(item);
      this.loadingStatusOnboarding = true;
    },
    async getBlacklist() {
      try {
        const result = await clientsService.getBlacklistTotal();
        const item = {
          name: "blacklist",
          value: Number(result.total) > 0 ? true : false,
        };
        this.setStatusOnboarding(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getData() {
      try {
        this.sincronized = 0;
        if (this.user.is_agency == 1) {
          const result = await usersService.getGroupList();
          this.dataUsers = result;
        } else {
          const result = await usersService.getAll();
          this.dataUsers = result;
        }

        this.dataUsers.forEach((res) => {
          if (Number(res.nylas_email_sync_status) === 1) {
            this.sincronized++;
          }
        });

        let calendarDone = false;
        try {
          if (this.user.switches) {
            calendarDone = !!JSON.parse(this.user.switches).calendar;
          }
        } catch (err) {
          calendarDone = false;
        }

        const allNylasSynced =
          this.dataUsers.length > 0 &&
          this.sincronized === this.dataUsers.length;

        const item = {
          name: "emailSincronized",
          value: calendarDone || allNylasSynced,
        };

        this.setStatusOnboarding(item);
      } catch (error) {
        console.log(error);
      }
    },
    goToPage(url) {},
    stopOndemand() {
      this.stopondemand = true;
    },
    toggleMinLink() {
      this.minlink = !this.minlink;
    },
    toggleMinOndemand() {
      this.minondemand = !this.minondemand;
    },
    refreshLinkedin() {
      this.keyLinkedin++;
    },

    mousedown(routeTo) {
      if (this.isMobile && this.$route.fullPath !== routeTo) {
        this.$refs.toggleMenu2.click();
        this.$router.push({
          path: routeTo,
        });
      }

      if (this.$route.fullPath == routeTo) {
        return;
      }

      if (this.$route.path.includes(routeTo)) {
        this.NavigationClicked();
        this.$router.push({
          path: routeTo,
        });
      }
    },
    checkRol(item) {
      const itemMenu = this.menu[item];
      const { linkTo } = this.menu[item];

      /*Si es usuario tipo Operativo (role_id = 1 y user_contraint_id = 1)
      Entonces esa opcion del menu no se mostrara */

      // if (this.isUserBilling && linkTo == '/activity') {
      if (
        this.user.role_id == 4 &&
        (this.user.team_role_id == 1 || this.user.team_role_id == 3) &&
        linkTo == "/activity"
      ) {
        let hasPermission = false;

        if (this.user.plan_id == "5" && this.user.subscription_free == "0") {
          hasPermission = true;
        }

        return hasPermission ? true : false;
      }

      if (this.isSaleOrAccountExecutive) {
        const menuContraintsToUserAccountExecutive = [
          "/syncemails/14",
          "/syncemails/",
          "/dashboard",
          "/meeting-attendance",
          "/campaigns",
          "/campaigns-health",
          "/opportunities",
          "/emails",
          "/calendars",
          "/usages",
          "/orders",
        ];

        return menuContraintsToUserAccountExecutive.includes(linkTo)
          ? false
          : true;
      }

      if (this.isUserAccountManager) {
        const menuContraintsToUserOperational = [
          "/meeting-attendance",
          "/syncemails/14",
        ];

        return menuContraintsToUserOperational.includes(linkTo) ? false : true;
      }

      if (this.isUserOperational) {
        const menuContraintsToUserOperational = [
          "/allperformances",
          "/allbdr",
          "/clients",
          "/calendars",
          "/client-subscriptions",
          "/orders",
          "/Affiliation",
          "/allinfrastructure",
          "/dashboard",
          "/campaigns",
          "/campaigns-health",
          "/link-claims",
          "/meeting-attendance",
          "/usages",
          "/activity",
          "/opportunities",
          "/oliver_sales_dashboard",
          "/orders_details",
          "/businesses",
          "/users",
          "/syncemails/14",
        ];

        return menuContraintsToUserOperational.includes(linkTo) ? false : true;
      }

      if (this.isUserSupport) {
        const menuContraintsToUserOperational = [
          "/allperformances",
          "/reports",
          "/syncemails/18",
          "/syncemails/",
          "/emails",
          "/link-claims",
          "/meeting-attendance",
          "/clients",
          "/calendars",
          "/client-subscriptions",
          "/orders",
          "/Affiliation",
          "/allinfrastructure",
          "/dashboard",
          "/campaigns",
          "/campaigns-health",
          "/usages",
          "/activity",
          "/oliver_sales_dashboard",
          "/orders_details",
          "/businesses",
          "/users",
          "/syncemails/14",
        ];

        return menuContraintsToUserOperational.includes(linkTo) ? false : true;
      }

      if (this.isUserAttendance) {
        const menuPermittedToUserAttendance = ["/attendance"];

        return menuPermittedToUserAttendance.includes(linkTo) ? true : false;
      }

      if (this.isUserContable) {
        const menuContraintsToUserContable = ["/usages"];

        return menuContraintsToUserContable.includes(linkTo) ? true : false;
      }

      if (this.isUserBookerRecuiter) {
        const menuContraintsToUserContable = [
          "/allbdr",
          "/settings-account",
          "/dashboard/tabs/21",
        ];

        return menuContraintsToUserContable.includes(linkTo) ? true : false;
      }

      if (this.hasPermissions("superAdmin")) {
        const menuContraintsToUserAdmin = [
          "/orders",
          "/dashboard",
          "/usages",
          "/dashboard/tabs/29",
          "/dashboard/tabs/14",
        ];
        return menuContraintsToUserAdmin.includes(linkTo) ? false : true;
      }

      //console.log('itemMenu...', itemMenu, 'link..', linkTo)

      if (itemMenu.submenu) {
        const findItemwithoutSubmenu = this.menu.find(
          (el) => el.linkTo == linkTo && !el.submenu
        );
        if (findItemwithoutSubmenu) {
          if (itemMenu.roles.includes(Number(this.user.role_id))) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        const findItemWithSubmenu = this.menu.find(
          (el) => el.linkTo == linkTo && el.submenu
        );

        if (findItemWithSubmenu) {
          //console.log('this.user.role_id....', this.user.role_id, 'link....', linkTo, 'itemMenu', itemMenu, 'roles...', itemMenu.roles, 'itemMenu.roles.includes(this.user.role_id)', itemMenu.roles.includes(this.user.role_id))
          if (itemMenu.roles.includes(Number(this.user.role_id))) {
            return true;
          } else {
            return false;
          }
        }
      }

      if (
        this.menu[item]["linkTo"] == "/emails" &&
        this.menu[item]["team_roles"] != undefined &&
        this.user.team_role_id !== null &&
        this.user.role_id != 4 &&
        $.inArray(
          parseInt(this.user.team_role_id),
          this.menu[item]["team_roles"]
        ) !== -1 &&
        $.inArray(parseInt(this.user.role_id), this.menu[item]["roles"]) !== -1
      ) {
        return true;
      } else {
        if (
          this.user.role_id == 1 &&
          this.menu[item]["linkTo"] != "/activity"
        ) {
          return true;
        }

        if (this.menu[item]["linkTo"] == "/emails" && this.user.role_id != 8) {
          return false;
        }
      }

      if (
        $.inArray(parseInt(this.user.role_id), this.menu[item]["roles"]) == -1
      ) {
        return false;
      } else {
        if (
          this.menu[item]["team_roles"] != undefined &&
          this.user.team_role_id !== null &&
          this.user.role_id != 4 &&
          $.inArray(
            parseInt(this.user.team_role_id),
            this.menu[item]["team_roles"]
          ) == -1
        ) {
          return false;
        }
      }
      return true;
    },
    checkPlan(item) {
      if (this.toastNotificationData.dontChargePayments == 1) {
        return true;
      } else if (
        this.user.subscription_status_id == 0 &&
        this.toastNotificationData.trialPeriodData.trial_period_ended == 0 &&
        this.menu[item]["trialPeriodAvailable"] != undefined &&
        this.menu[item]["trialPeriodAvailable"] == false
      ) {
        return false;
      } else if (
        this.menu[item]["planIdAccess"] != undefined &&
        $.inArray(
          parseInt(this.user.plan_id),
          this.menu[item]["planIdAccess"]
        ) == -1
      ) {
        return false;
      } else {
        return true;
      }
    },
    getAgencySigned() {
      if (this.user && this.user.role_id == 4 && this.user.agency_signed == 0) {
        this.agency_signed = false;
      }
    },

    updateStatusMenu(menuOption) {
      this.menu
        .find((el) => el.id == menuOption)
        .submenu.forEach((e) => {
          if (e.count != false && e.count != "0") {
            this.menu.find((el) => el.id == menuOption).hasTasks = true;
          }
        });
    },
    getCalendarDomains(menu = null, submenuId = null) {
      this.completeLoading = false;
      workspaceService
        .getWorkspaceDomains("", "all_inactive", true)
        .then((result) => {
          this.menu
            .find((el) => el.id == menu)
            .submenu.find((el) => el.id == submenuId).count = result.count
            ? result.count
            : "0";
          this.updateStatusMenu(menu);
        });
    },
    getClientWithoutOliverSales(
      count = 0,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      const itemSelected = tab ? tab : this.itemSelected;
      monitorService
        .getClientWithoutOliverSales(itemSelected, count)
        .then((result) => {
          if (count) {
            this.menu
              .find((el) => el.id == menu)
              .submenu.find((el) => el.id == submenuId).count = result.result
              .count
              ? result.result.count
              : "0";
            this.updateStatusMenu(menu);
          }
        });
    },

    getNotProspectingSales(
      count = 0,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      const itemSelected = tab ? tab : this.itemSelected;
      targetsService
        .getNotProspectingSales(itemSelected, count)
        .then((result) => {
          if (count) {
            this.menu
              .find((el) => el.id == menu)
              .submenu.find((el) => el.id == submenuId).count = result.result
              .count
              ? result.result.count
              : "0";
            this.updateStatusMenu(menu);
          }
        });
    },

    getEmailsConfigSmtp(
      count = 0,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      const itemSelected = tab ? tab : this.itemSelected;
      monitorService.getEmailsConfigSmtp(itemSelected, count).then((result) => {
        if (count) {
          this.menu
            .find((el) => el.id == menu)
            .submenu.find((el) => el.id == submenuId).count = result.result
            .count
            ? result.result.count
            : "0";
          this.updateStatusMenu(menu);
        }
      });
    },

    getTargetListNotesTotal(
      count = 0,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      const itemSelected = tab ? tab : this.itemSelected;
      targetsService.getTargetListNotes(itemSelected, count).then((result) => {
        this.owarmStats = result.result;
        if (count) {
          this.menu.find((el) => el.id == menu).count = result.result.count
            ? result.result.count
            : "0";
          this.updateStatusMenu(menu);
        }
      });
    },

    getDomainsToBuy(
      count = 0,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      workspaceService.getDomainsToBuy("count").then((result) => {
        if (count) {
          this.menu
            .find((el) => el.id == menu)
            .submenu.find((el) => el.id == submenuId).count = result.count
            ? result.count
            : "0";
          this.updateStatusMenu(menu);
        }
      });
    },

    getCommercialWithoutEmailsTotal(
      count = 0,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      const itemSelected = tab ? tab : this.itemSelected;
      adminService
        .getTargetSalesWithoutProspectors(itemSelected, count)
        .then((result) => {
          this.owarmStats = result.result;
          if (count) {
            this.menu
              .find((el) => el.id == menu)
              .submenu.find((el) => el.id == submenuId).count = result.result
              .count
              ? result.result.count
              : "0";
            this.updateStatusMenu(menu);
          }
        });
    },
    getOwarmStats(
      count = 0,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      const itemSelected = tab ? tab : this.itemSelected;
      adminService.getListOwarm(itemSelected, count).then((result) => {
        this.owarmStats = result.result;
        if (count) {
          this.menu
            .find((el) => el.id == menu)
            .submenu.find((el) => el.id == submenuId).count = result.result
            .count
            ? result.result.count
            : "0";
          this.updateStatusMenu(menu);
        }
      });
    },
    getTargetMissingData(
      count = 0,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      const itemSelected = tab ? tab : this.itemSelected;

      targetsService
        .getTargetMissingData(itemSelected, count)
        .then((result) => {
          this.targetMissinDataItems = result;
          if (count) {
            this.menu
              .find((el) => el.id == menu)
              .submenu.find((el) => el.id == submenuId).count = result.count
              ? result.count
              : "0";
            this.updateStatusMenu(menu);
          }
        });
    },
    getListOwarm(count = 0, tab = null) {
      const itemSelected = tab ? tab : this.itemSelected;

      targetsService
        .getTargetContactSupply(itemSelected, count)
        .then((result) => {
          if (count) {
            this.tabs[tab].total = result.count ? result.count : "0";
          }
        });
    },
    getTargetContactSupply(
      count = 0,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      this.completeLoading = false;
      const itemSelected = tab ? tab : this.itemSelected;

      this.menu
        .find((el) => el.id == menu)
        .submenu.find((el) => el.id == submenuId).count = 0;
      let submenuAux = submenuId;
      submenuId = 1;
      targetsService
        .getTargetContactSupply(itemSelected, count, oliver_sale_id, submenuId)
        .then((result) => {
          if (count) {
            this.menu
              .find((el) => el.id == menu)
              .submenu.find((el) => el.id == submenuAux).count = result.count
              ? result.count
              : "0";
            this.updateStatusMenu(menu);
          }

          this.completeLoading = true;
        });
    },
    getClientAttribution(
      count = 0,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      this.completeLoading = false;
      const itemSelected = tab ? tab : this.itemSelected;

      targetsService
        .getClientAttribution(itemSelected, count)
        .then((result) => {
          //this.targetMissinDataItems = result;
          if (count) {
            //this.tabs[tab].total = result.count ? result.count : "0";
            this.menu
              .find((el) => el.id == menu)
              .submenu.find((el) => el.id == submenuId).count = result.count
              ? result.count
              : "0";
          }

          this.completeLoading = true;
        });
    },

    getSalesBurnedDomains(
      count = 0,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      this.completeLoading = false;
      const itemSelected = tab ? tab : this.itemSelected;

      usersService.getSalesBurnedDomains(itemSelected, count).then((result) => {
        //this.targetMissinDataItems = result;
        if (count) {
          //this.tabs[tab].total = result.count ? result.count : "0";
          this.menu
            .find((el) => el.id == menu)
            .submenu.find((el) => el.id == submenuId).count = result.result
            .count
            ? result.result.count
            : "0";
        }

        this.completeLoading = true;
      });
    },
    getOrderWarning(type, menu, submenuId) {
      let body = {
        [type]: true,
        count: true,
      };

      targetsService.getOrderWarning(body).then((result) => {
        this.menu
          .find((el) => el.id == menu)
          .submenu.find((el) => el.id == submenuId).count = result.count
          ? result.count
          : "0";
      });
    },

    getPhoneLookup(
      count = 0,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      this.completeLoading = false;
      const itemSelected = tab ? tab : this.itemSelected;

      opportunitiesService
        .getPhoneLookup(itemSelected, count)
        .then((result) => {
          //this.targetMissinDataItems = result;
          if (count) {
            //this.tabs[tab].total = result.count ? result.count : "0";
            this.menu
              .find((el) => el.id == menu)
              .submenu.find((el) => el.id == submenuId).count = result.count
              ? result.count
              : "0";
          }

          this.completeLoading = true;
        });
    },

    getEmailSyncList(
      count = null,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      if (!count) {
        this.lastGetListRequest = tab;
        this.completeLoading = false;
      }

      const itemSelected = tab ? tab : this.itemSelected;
      adminService.getEmailSyncList(itemSelected, count).then(
        (result) => {
          if (count) {
            this.menu
              .find((el) => el.id == menu)
              .submenu.find((el) => el.id == submenuId).count = result.count
              ? result.count
              : "0";
            this.updateStatusMenu(menu);
          }
          // else {
          //   if (itemSelected == this.lastGetListRequest) {
          //     this.list = result;
          //     this.completeLoading = true;
          //   }
          // }
        },
        (error) => {
          this.$store.dispatch("alert/error", error, { root: true });
        }
      );
    },
    getTargetNotes(
      count = 0,
      tab = null,
      status = 0,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      this.menu
        .find((el) => el.id == menu)
        .submenu.find((el) => el.id == submenuId).count = 0;
      targetsService.getTargetListNotes(tab, count, status).then((result) => {
        if (count) {
          this.menu
            .find((el) => el.id == menu)
            .submenu.find((el) => el.id == submenuId).count = result.result
            .count
            ? result.result.count
            : "0";
          this.updateStatusMenu(menu);
        }
      });
    },
    getMicrosoftLicences(
      count = 0,
      tab = null,
      status = 0,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      adminService.getMicrosoftLicences().then((result) => {
        let totalCount = 0;
        result.result.forEach((item) => {
          totalCount += parseInt(item.count);
        });
        this.menu
          .find((el) => el.id == "configuration")
          .submenu.find((el) => el.id == 25).count = totalCount
          ? totalCount
          : "0";
        this.updateStatusMenu("configuration");
      });
    },

    getTargetToProfitability(
      count = 0,
      tab = null,
      condition = 0,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      this.completeLoading = false;
      const itemSelected = tab ? tab : this.itemSelected;

      targetsService
        .getTargetListToProfitability(
          itemSelected,
          count,
          condition,
          oliver_sale_id
        )
        .then((result) => {
          //this.targetMissinDataItems = result;
          if (count) {
            this.menu
              .find((el) => el.id == menu)
              .submenu.find((el) => el.id == submenuId).count = result.result
              .count
              ? result.result.count
              : "0";
            this.updateStatusMenu(menu);
          }
          this.completeLoading = true;
        });
    },
    getCountWac(
      count,
      tab = null,
      oliver_sale_id = 0,
      menu = null,
      submenuId = null
    ) {
      targetsService
        .getFinishedTarget(count, tab, oliver_sale_id)
        .then((res) => {
          if (count) {
            this.menu
              .find((el) => el.id == menu)
              .submenu.find((el) => el.id == submenuId).count = res.count
              ? res.count
              : "0";
            this.updateStatusMenu(menu);
          }
        });
    },
  },
};
</script>

<style scoped>
.mobilenav {
  max-height: 500px;
  overflow-y: scroll;
}

.mobilenav .nav-item .nav-link {
  padding-left: 10px !important;
}

#main-navbar {
  width: 280px !important;
}

#main-navbar,
#main-navbar ul li,
#main-navbar img,
#main-navbar .dropdown-description {
  transition: all 0.5s;
}

/* Color de iconos del sidebar (mismo que colorIcon(): #7A7B9E) */
#main-navbar .nav-link i,
#main-navbar .nav-item > div > i {
  color: #7a7b9e !important;
}

/* Scrollbar derecho del menú booker: mismo tono que el fondo para que no se vea como barra negra */
#main-navbar .navbar-nav::-webkit-scrollbar-track,
#main-navbar .navbar-nav::-webkit-scrollbar-thumb {
  background: #fbfbfa !important;
}

.supporttechnique {
  position: fixed;
  bottom: 4px;
  right: 180px;
  z-index: 9999;
}

.collapseNav #main-navbar {
  width: 60px !important;
}

.collapseNav {
  width: 60px !important;

  .logooliver {
    width: 55px;
  }

  .item-name .title,
  .dropdown-description {
    display: none;
  }

  .navbar-nav {
    width: 60px;
  }

  .img-user {
    width: 25px;
  }

  .nav-link i {
    font-size: 15px;
  }

  .navbar-nav .dropdown-menu {
    min-width: 60px;
    border-radius: 0px;

    .dropdown-item {
      padding: 0.25rem 1.4rem;
    }
  }

  .btn-toggleCollapse i.icon-angle-left {
    -moz-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}

.notif {
  right: 10px;
}

.navbar-nav .btn-toggleCollapse i.icon-angle-left {
  -moz-transition: all 0.3s linear;
  -webkit-transition: all 0.3s linear;
  transition: all 0.3s linear;
}

.navbar-nav .dropdown-menu {
  min-width: 180px;
  border-radius: 0px;

  .dropdown-item {
    padding: 0.25rem 1.4rem;
  }
}

.notification-linkedin {
  position: fixed;
  bottom: 0;
  z-index: 999;
  width: 200px;
}

.minimize-linkedin {
  z-index: 1000;
  right: 0;
  padding: 0px 5px;
}

.user-name {
  display: block;
}

/* Por defecto sidebar oscuro (admin y otros roles). El booker lo sobrescribe con :style="bgGrayBooker" */
div#navbarSupportedContent {
  background-color: #fbfbfa;
}

.btn-toggleCollapse {
  position: absolute;
  right: -10px;
  border-radius: 50%;
  height: 25px;
  width: 25px;
  z-index: 3;
  background: #1f2041;
  border: none;
  color: #fff;
  font-size: 12px;
  bottom: 30px;

  &:hover {
    background: #13143a;
  }
}

.img-user {
  width: 35px;
}

.logooliver {
  width: 100px;
}

.logoMerciHubert {
  width: 120px;
}

.navbar .nav-item .nav-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.billingClassMenu {
  padding: 4.5px;
}

.link-logout {
  padding-bottom: 40px;
}

.link-logout .nav-link {
  line-height: 0;
}

.sidebar-bottom-li {
  list-style: none;
  margin-top: auto;
  flex-shrink: 0;
}

.sidebar-bottom {
  padding: 1rem 0.5rem 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.sidebar-updated {
  font-size: 0.8rem;
  margin-bottom: 0.75rem;
  opacity: 0.85;
}

.navbar .navbar-nav {
  padding-top: 2em !important;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.mobilenav.navbar .navbar-nav {
  padding-top: 0em !important;
}

.border-color {
  border: 2px solid #ffffff;
}

.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 9px;
  padding: 0 !important;
  color: #fff !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.text-blue {
  color: rgb(28, 30, 151);
}

/* Azul claro al pasar el ratón: ítems sin submenú (router-link tiene hover-booker, el .nav-link se pinta) */
.hover-booker:hover .nav-link:hover {
  background-color: #bec2da !important;
}

/* Ítems CON submenú: el li tiene hover-booker; _main.scss pinta el .nav-item de gris oscuro.
   Forzamos azul claro en el li para que se vea igual que los ítems sin submenú. */
#main-navbar .nav-item.hover-booker:hover {
  background-color: #bec2da !important;
}

#main-navbar .nav-item.hover-booker:hover .nav-link {
  background-color: transparent !important;
}

/* Opciones del submenú en azul (mismo que el menú principal), no en blanco */
#main-navbar .navbar-nav .nav-link.text-blue,
#main-navbar .navbar-nav .nav-item .nav-link.text-blue {
  color: rgb(28, 30, 151) !important;
}

/* Texto negro en sidebar: gana sobre .navbar .nav-link { color: #fff } de _main.scss */
#main-navbar .nav-link.text-black,
#main-navbar .navbar-nav .nav-item .nav-link.text-black {
  color: #000 !important;
}

/* Quitar gris oscuro al seleccionar una opción del submenú (router-link-active / .active) */
#main-navbar .navbar-nav a.router-link-active .nav-item,
#main-navbar .navbar-nav a.active .nav-item,
#main-navbar .navbar-nav .router-link-active .nav-item {
  background-color: transparent !important;
}

#main-navbar .navbar-nav a.router-link-active .nav-link,
#main-navbar .navbar-nav a.active .nav-link {
  background-color: transparent !important;
  color: rgb(28, 30, 151) !important;
}

/* ——— Admin sidebar redesign (role_id === 1) ——— */
.sidebar-redesign-nav {
  --ol-sidebar-bg: #fbfbfa;
  --ol-sidebar-inset-x: 10px;
  --ol-border: #ededec;
  --ol-text: #1a1a18;
  --ol-text-secondary: #6b6b67;
  --ol-text-tertiary: #9a9a96;
  --ol-hover: #f0f0ee;
  --ol-active: #ebebe9;
  --ol-accent: #5054EB;
  --ol-accent-soft: #f3f1fd;
  --ol-radius: 8px;
}

.sidebar-redesign-nav#navbarSupportedContent,
.sidebar-redesign-nav #navbarSupportedContent {
  background-color: var(--ol-sidebar-bg) !important;
  width: 268px;
  max-width: 268px;
}

.sidebar-redesign-nav .navbar-nav {
  padding: 0.875rem var(--ol-sidebar-inset-x) 0 !important;
  width: 100%;
  align-items: stretch;
  text-align: left;
  display: flex !important;
  flex-direction: column;
  height: 100vh;
  min-height: 0;
  overflow: hidden !important;
}

.sidebar-redesign {
  padding: 0 0 8px;
}

.ol-family-label {
  display: block;
  width: 100%;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ol-text-tertiary);
  padding: 6px 10px 4px;
  margin-top: 12px;
  text-align: left;
}

.ol-sidebar-family:first-child .ol-family-label {
  margin-top: 0;
}

.ol-nav-item-link {
  display: block;
  text-decoration: none !important;
  color: inherit;
  margin: 1px 0;
}

.ol-sub-item-link {
  display: block;
  text-decoration: none !important;
  color: inherit;
}

.ol-nav-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 11px;
  padding: 8px 9px;
  border-radius: var(--ol-radius);
  font-size: 13.5px;
  color: var(--ol-text);
  cursor: pointer;
  user-select: none;
  text-align: left;
}

.ol-nav-item--parent {
  width: 100%;
}

.ol-nav-item-link:hover .ol-nav-item,
.ol-nav-item--parent:hover {
  background: var(--ol-hover);
}

.ol-nav-item-link.ol-active .ol-nav-item,
.ol-sub-item-link.ol-active .ol-sub-item {
  background: var(--ol-active);
  font-weight: 600;
}

.ol-sub-item-link.ol-active .ol-sub-item {
  background: var(--ol-accent-soft);
  color: var(--ol-accent);
}

.ol-nav-icon {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--ol-text-secondary);
  flex-shrink: 0;
}

.ol-nav-item-link.ol-active .ol-nav-icon {
  color: var(--ol-accent);
}

.ol-nav-label {
  flex: 1 1 auto;
  min-width: 0;
  line-height: 1.3;
  text-align: left;
}

.ol-chev {
  margin-left: auto;
  color: var(--ol-text-tertiary);
  font-size: 10px;
  transition: transform 0.18s ease;
}

.ol-nav-group > .ol-nav-item--parent .ol-chev {
  transform: rotate(-90deg);
}

.ol-nav-group.open > .ol-nav-item--parent .ol-chev {
  transform: rotate(0deg);
}

.ol-submenu {
  margin: 2px 0 4px;
  padding-left: 4px;
}

.ol-sub-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 6px 9px 6px 30px;
  border-radius: 6px;
  font-size: 12.8px;
  color: var(--ol-text-secondary);
  position: relative;
  text-align: left;
}

.ol-sub-label {
  flex: 1 1 auto;
  min-width: 0;
  text-align: left;
}

.ol-sub-item-link:hover .ol-sub-item {
  background: var(--ol-hover);
  color: var(--ol-text);
}

.ol-badge {
  margin-left: auto;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: var(--ol-accent);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ol-badge--loading {
  font-size: 10px;
}

.ol-sidebar-footer {
  padding-top: 10px;
  border-top: 1px solid var(--ol-border);
}

.ol-sidebar-footer .ol-nav-item-link {
  display: block;
  margin: 1px 0;
}

.ol-sidebar-footer .ol-nav-item {
  color: var(--ol-text-secondary);
}

.ol-sidebar-footer .ol-nav-item-link:hover .ol-nav-item {
  background: var(--ol-hover);
  color: var(--ol-text);
}

.ol-sidebar-footer .ol-nav-item-link:hover .ol-nav-icon {
  color: var(--ol-text-secondary);
}

.sidebar-redesign-nav .ol-sidebar-brand,
.sidebar-redesign-nav .logooliver.ol-sidebar-brand {
  display: block;
  width: auto;
  height: auto;
  max-width: 60%;
  margin: 0 !important;
  padding: 6px 8px 18px;
}

.sidebar-redesign-nav .navbar-nav > div {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
  overflow: hidden;
}

.sidebar-admin-layout {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.sidebar-admin-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

#main-navbar.sidebar-redesign-nav .sidebar-admin-scroll::-webkit-scrollbar {
  width: 5px;
}

#main-navbar.sidebar-redesign-nav
  .sidebar-admin-scroll::-webkit-scrollbar-track,
#main-navbar.sidebar-redesign-nav
  .sidebar-admin-scroll::-webkit-scrollbar-thumb {
  background: #fbfbfa !important;
}

.sidebar-admin-footer {
  flex-shrink: 0;
}

.sidebar-redesign-nav .sidebar-redesign-gate {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
  overflow: hidden;
}

.sidebar-redesign-nav .sidebar-client-host {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
}

.sidebar-redesign-nav .sidebar-booker-host {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
  overflow: hidden;
}

.sidebar-redesign-nav .sidebar-bottom-li {
  width: 100%;
}

/* Ítems legacy (huérfanos) dentro del sidebar admin: alinear texto a la izquierda */
.sidebar-redesign-nav .nav-link,
.sidebar-redesign-nav .item-name,
.sidebar-redesign-nav .item-name .title {
  justify-content: flex-start !important;
  text-align: left !important;
}

.sidebar-redesign-nav .nav-item .nav-link {
  display: flex !important;
  align-items: center !important;
}
</style>

<style>
@media (max-width: 900px) {
  div.w-50 {
    width: 100% !important;
    max-width: 100% !important;
  }
}
@media (max-width: 900px) {
  div.w-25 {
    width: 100% !important;
    max-width: 100% !important;
  }
}

.table-hover tbody tr:hover {
  color: #212529;
  background-color: rgb(68 60 236 / 14%) !important;
}
</style>
